import { render, staticRenderFns } from "./CargoPage.vue?vue&type=template&id=346f5020"
import script from "./CargoPage.js?vue&type=script&lang=js&external"
export * from "./CargoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports